import React from 'react';

import type { SideNavigationSectionProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { isMobileAllowed } from '@lumapps/mobile/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';

import { ContentStreamsSideNavigation as ContentStreamsSideNavigationOriginal } from './ContentStreamsSideNavigation';

export const ContentStreamsSideNavigation: React.FC<Partial<SideNavigationSectionProps>> = (props) => {
    const isAllowed = useSelector(isMobileAllowed);

    return <ContentStreamsSideNavigationOriginal {...props} isAllowed={isAllowed} />;
};

ContentStreamsSideNavigation.displayName = 'SideNavigationItem';
